module.exports = __webpack_public_path__ + "img/subjective-detection.d0fe7146.png";